import React, { useContext, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { createUserWithEmailAndPassword, AuthErrorCodes } from "firebase/auth";
import { Button, Header, Input } from "../../../components";
import { auth, db } from "../../../firebase";
import authStyles from "../Auth.module.css";
import { LogoMedium, WorkHard } from "../../../components/Images/Images";
import { addDoc, collection, doc, setDoc } from "firebase/firestore";
import { UserContext } from "../../../contexts/userContext";
import { authErrorMessages } from "../utils";

function Signup(props) {
  const navigate = useNavigate();

  const {setUserLoading} = useContext(UserContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const handleChange = (e) => {
    let formValuesTemp = { ...formValues };
    formValuesTemp[e.target.name] = e.target.value;
    setFormValues(formValuesTemp);
  };

  const createUserProfile = async (user) => {
    const {email, uid} = user
    await setDoc(doc(db, "users", uid), {email});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setUserLoading(true)
    setError();

    createUserWithEmailAndPassword(
      auth,
      formValues?.email,
      formValues?.password
    )
      .then(async (userCredential) => {
        // Signed in
        const user = userCredential.user;

        // create an entry in users collection
        await createUserProfile(user)
        setLoading(false);
        if (!props.modal) {
          navigate("/");
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        console.log(errorCode, AuthErrorCodes);
        setLoading(false);
        setError(errorCode);
      });
  };

  const handleLogin = () => {
    setSearchParams({ ...searchParams, auth: "login" });
  };

  return (
    <div className={authStyles.authWrapper}>
      <div className={authStyles.container}>
        <div className={authStyles.innerContainer}>
          <Header
            className={authStyles.heading}
            content={
              <>
                Create new account{" "}
                <span style={{ fontSize: 16, float: "right", marginTop: 2 }}>
                  Or{" "}
                  {props.modal ? (
                    <Button onClick={handleLogin} type="link" content="Login" />
                  ) : (
                    <Link to="/login" className={authStyles.link} type="link">
                      Login
                    </Link>
                  )}
                </span>
              </>
            }
            subheading="And start building your job-landing resume"
          />
          <form onSubmit={handleSubmit}>
            <div className={authStyles.margin}>
              <Input
                label="Email"
                type="email"
                name="email"
                onChange={handleChange}
              />
            </div>
            <div className={authStyles.margin}>
              <Input
                label="Password"
                type="password"
                name="password"
                onChange={handleChange}
              />
            </div>
            <div className={authStyles.margin}>
              <Button
                content="Create Account"
                type="submit"
                loading={loading}
                disabled={!(formValues.email && formValues.password)}
              />
            </div>
          </form>
          <p className={authStyles.errorMessage}>{authErrorMessages[error]}</p>
          <p style={{ fontSize: 11 }}>
            By continuing, you agree to our Customer{" "}
            <a href="https://bigresume.io/pages/tnc.html" target="_blank">
              Terms of Service
            </a>{" "}
            and{" "}
            <a target="_blank" href="https://bigresume.io/pages/privacy.html">
              Privacy Policy
            </a>
          </p>
        </div>
        <div className={authStyles.imageWrapper}>
          <img src={LogoMedium} className={authStyles.logo} />
          <img className="image" src={WorkHard} />
        </div>
      </div>
    </div>
  );
}

export default Signup;
